import React from 'react';
import { NavLink } from 'react-router-dom';
import ReactGA from 'react-ga';
import headerNavLinks from '../../data/headerNavLinks';
import SectionContainer from '../section_container/SectionContainer';
import Footer from '../footer/Footer';
import MobileNav from '../mobile_nav/MobileNav';
import { ReactComponent as Logo } from '../../data/logo.svg';
import { ReactGAEvents } from '../../utils/Constants';


const LayoutWrapper = ({ children }) => {
    return (
        <SectionContainer>
            <div className="flex flex-col justify-between h-screen">
                <header className="flex items-center justify-between py-8">
                    <div>
                        <NavLink
                            to="/"
                            onClick={() => {
                                ReactGA.event({
                                    category: ReactGAEvents.InternalLink,
                                    action  : 'Clicked Internal Link /',
                                });
                            }}
                            aria-label="mattthewong's site"
                            className="hover:no-underline group"
                        >
                            <div className="flex items-center justify-between">
                                <div className="mr-3 opacity-90 group-hover:opacity-100 transition-opacity">
                                    <Logo />
                                </div>
                            </div>
                        </NavLink>
                    </div>
                    <div className="flex items-center text-sm leading-5 font-mono">
                        <div className="hidden sm:block">
                            {headerNavLinks.map((link) => {
                                return (
                                    <NavLink
                                        key={link.title}
                                        to={link.href}
                                        onClick={() => {
                                            ReactGA.event({
                                                category: ReactGAEvents.InternalLink,
                                                action  : `Clicked Internal Link ${link.href}`,
                                            });
                                        }}
                                        className="text-neutral-400 hover:text-red-500 sm:p-4 transition-colors duration-200"
                                    >
                                        {link.title}
                                    </NavLink>
                                );
                            })}
                        </div>
                        <MobileNav />
                    </div>
                </header>
                <main className="mb-auto">{children}</main>
                <Footer />
            </div>
        </SectionContainer>
    );
};

export default LayoutWrapper;
